import { module } from './store'
import { createModule } from '@vue-storefront/core/lib/module'

export const KEY = 'products_categories'
export const ProductsCategories = createModule({
  key: KEY,
  store: { modules: [{ key: KEY, module }] }
})
